import { useLang } from "../contexts/LanguageContext";

/**
 * Returns a function that picks between the ID URL and the EN URL based on current language.
 * Usage:
 *   const lp = useLocalized();
 *   <Link to={lp("/proyek", "/en/projects")} />
 */
export function useLocalized() {
  const { lang } = useLang();
  return (idPath, enPath) => (lang === "en" ? enPath : idPath);
}
